module.exports = __webpack_public_path__ + "thirdpartyteachersmallwp2debf70a49346a8f8c61db4316ef0ce4.png";